import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerFacebookPageAnalyticsPostsByDate.graphql';
import { Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs } from '../../__generated__/globalTypes';

export const useInfluencerFacebookPageAnalyticsPostsByDateQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerFacebookPageAnalyticsPostsByDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>
): QueryResult<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs> & {
  getInfluencerFacebookPageAnalyticsPostsByDate: LazyQueryExecFunction<
    Query,
    QueryinfluencerFacebookPageAnalyticsPostsByDateArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerFacebookPageAnalyticsPostsByDate, result] = useLazyQuery<
    Query,
    QueryinfluencerFacebookPageAnalyticsPostsByDateArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerFacebookPageAnalyticsPostsByDate, ...result };
};

export const useInfluencerFacebookPageAnalyticsPostsByDatePromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerFacebookPageAnalyticsPostsByDate = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerFacebookPageAnalyticsPostsByDateArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerFacebookPageAnalyticsPostsByDate };
};
// Suspense Query Hooks
export const useInfluencerFacebookPageAnalyticsPostsByDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerFacebookPageAnalyticsPostsByDateArgs>(QUERY, {
    ...options
  });

  return result;
};
